import * as React from 'react';
import { Box } from '@mui/material';
const Copyright = () => {
    return (
        <Box sx={{fontSize: 12}}>
            COPYRIGHT © 2026 DeepBlock. ALL RIGHTS RESERVED.
        </Box>
    )
};

export default Copyright;
